export const URL = {
  Home: "/",
  Login: "/login",
  GetStarted: "/get-started",
  ForgotPassword: "/forgot-password",
  ResetPassword: "/reset",
  SignUp: "/sign-up",
  Email_Verified: "/email-verified",
  Dashboard: "/dashboard",
  Onboarding: "onboarding",
  Palliative: "palliative",

  //Vendors
  Vendors: "vendors",
  Vendors_Onboarding: "onboarding",
  Vendors_Management: "management",
  Vendors_Approval: "approval",
  Add_Vendor: "add-vendor",
  Create_Vendor: "create-vendor",
  View_Vendor: "view-vendor",
  All_Requisition: "Requisition",
  All_Quotation: "Quotation",
  Line_Manager_Appraisal: "line-manager-appraisal",
  //Procurement
  Procurement: "procurement",
  Requisition_Management: "requisition",
  Waiver_Management: "waiver-management",
  Quotation_Management: "quotation",
  Delivery: "delivery",
  Maintenance: "maintenance",
  vendorPayment: "vendor-payment",

  // Employee Service
  EmployeeService: "employee-service",
  Management: "management",
  ControlReview: "control-review",

  //Assets Routes
  Assets: "assets",
  Acquisition: "Acquisition",
  Add_Acquitions: "Add-Acquisition",
  View_Acquisition: "View-Acquisition",
  Requisition: "Requisition",
  Allocation: "Allocation",
  Monitoring: "Monitoring",
  Auctioning: "Auctioning",
  AuctionBidding: "Auctioning-Bidding",
  Report: "Report",
  Asset_Management: "Asset-Management",
  Asset_Configuration: "Asset-Configuration",
  Self_Appraisal: "Self-Appraisal",
  //Fleets Routes
  Fleets: "fleets",
  Fleet_Management: "fleet-mgt",
  All_fleet: "All-Fleet",
  //Requisition:"Requisition",
  Add_Requisitions: "Add-Requisition",
  View_Requisitions: "view-requisition",
  My_Requisitions: "my-requisition",
  Fuel_Payment: "fuel-payment",
  My_Payment: "my-payment",

  Driver_Activity: "driver-activity",
  Add_Activity: "add-activity",
  All_DriverActivity: "all-activity",
  Movement: "movement-summaries",
  // Add_Activity: "add-activity",
  // All_DriverActivity: "all-activity",
  Vehicle_Maintenance: "Vehicle-Maintenance",
  Accident_Report: "Accident-Report",
  Driver_Activities: "Driver-Activities",
  Vehicle_Document: "Vehicle-Document",
  Vehicle_Document_SetUp: "Vehicle-Document-SetUp",

  // Reports
  Reports: "reports",
  Generate_Report: "generate-report",
  Report_configuration: "report-configuration",
  Report_scheduler: "report-scheduler",
  Trigger_History: "trigger-history",

  Inventory: "inventory",
  //HR Routes
  HR: "hr",
  Leave_SetUp: "Leave-SetUp",
  Payroll_Setup: "Payroll-SetUp",
  Add_Payroll_items: "Add-Payroll-item",
  Leave_Main: "Leave-Main",
  Leave_Approval: "Leave-Approval",
  Leave_HOD: "Leave-HOD",
  Training_SetUp: "Training-SetUp",
  Training_Request: "Training-Request",
  Exit_Discussion_SetUp: "Exit-Discussion-SetUp",
  Overtime_Setup: "Overtime-Setup",
  Overtime_Management: "Overtime-Management",
  MANAGEMENT_OBJECTIVE: "Management-Objectives",
  MANAGEMENT_APPRAISAL: "Management-Appraisal-HOD",
  APPRAISAL_REVIEW_MGT: "Appraisal-Management",
  Development_Plan: "Development-Plan",
  Expected_Improvement_Plan: "Expected-Improvement-Plan",
  Exit_Management: "Exit-Management",
  Query_SetUp: "Query-SetUp",
  Query_Management: "Query-Management",
  Employee_Setup: "Employee-Setup",
  Add_Panel: "add-panel",
  All_Query_Management: "All-query-management",
  Employee_Management: "Employee-Management",
  NOK_Information: "NOK-Information",
  Add_NOK: "Add-NOK",
  Medical_Requisition: "Medical-Requisition",
  Add_Medical: "Add-Medical",
  Employee_Qualifications: "Employee-Qualifications",
  Employee_Claims: "Employee-Claims",
  Employee_Referees: "Employee-Referee",
  Recruitment_Service: "recruitment-service",
  Job_Title_Update: "job-title-update",
  Initiate_Recruitment: "initiate-recruitment",
  Update_Recruitment: "update-recruitment",
  Recruitment_Details: "recruitment-details",
  Recruitment_Process: "recruitment-process",
  Recruitment_Process_Ed: "recruitment-process-ed",
  Recruitment_Process_Md: "recruitment-process-md",
  Recruitment_Process_Details: "recruitment-process-details",
  Recruitment_Process_Review: "recruitment-process-review",
  Recruitment_Review_Details: "recruitment-review-details",
  Recruitment_Review_Group: "recruitment-review-group",
  Upload_Medical_Form: "upload-medical-form",
  Recruitment_Comment: "recruitment-comment",
  Schedule_Interview: "schedule-interview",
  Job_Application: "job-application",
  Recruitment_Setup: "recruitment-setup",
  Setup_Jobtitle: "setup-jobtitle",
  General_Recruitment_Setup: "setup",
  Job_Title_Details: "job-title-details",
  Set_Skills: "set-skills",
  Set_Up_Skills: "set-up-skills",
  Skills_Details: "skills-details",
  Qualification_Setup: "qualification-setup",
  Setup_Qualification: "setup-qualification",
  Qualification_Details: "qualification-details",
  Metrics_Setup: "metrics-setup",
  Setup_Metrics: "setup-metrics",
  Metrics_Details: "metrics-details",
  Application_Channel_Setup: "application-channel-setup",
  JobList_Setup: "joblist-setup",
  Setup_JobList: "setup-joblist",
  Setup_Application_Channel: "setup-application-channel",
  Application_Channel_Details: "application-channel-details",
  Medical: "medical",
  Medical_Service_Setup: "medical-service-setup",
  Add_New_Hospital: "add-new-hospital",
  Employee_Medical_Limit: "employee-medical-limit",
  Medical_Service: "medical-service",
  Medical_Report: "medical-report",
  Payroll_ComponentTable: "Payroll-ComponentTable",
  PayTest: "paytest",
  PayTester: "paytester",
  Ori: "ori",
  Update_Payroll: "update-payroll",
  Attendance_Clock: "attendance-clock",
  Clock_Setting: "clock-setting",
  Update_Clock: "update-clock",
  Clock_Setup: "clock-setup",
  Employee_Group: "employee-group",
  Add_Employee_Group: "add-employee-group",
  Update_Employee_Group: "update_employee_group",
  Employee_Cadre_Position: "employee-cadre-position",
  Add_Employee_Cadre_Position: "add-employee-cadre-position",
  Update_Employee_Cadre_Position: "update-employee-cadre-position",
  Employee_Cadre_Position_Level: "employee-cadre-position-level",
  Add_Employee_Cadre_Position_Level: "add-employee-cadre-position-level",
  Update_Employee_Cadre_Position_Level: "update-employee-cadre-position-level",
  Appraisal_Setup: "HR-Appraisal-Setup",
  Appraisal_HR: "Appraisal-HR",
  CommitteeList: "Committee-List",
  Appraisal_Manage_Objectives: "Manage-Objectives",
  View_Appraisal_Objectives: ":id/view",
  Key_Result_Area: "key-result-area",
  View_Key_Result_Area: ":id/view",
  Appraisal_Period: "appraisal-period",
  Rating_Scale: "rating-scale",
  Score_Base_Recommendations: "Score-Base-recommendations",
  View_Score_Base_recommendation: ":id/view",
  VIEW_RATING_SCALE: ":id/view",
  Performance_StatusLabel: "performance-status-label",
  VIEW_PERFORMANCE_STATUS_LABEL: ":id/view",
  Counselling_type: "Counselling-Type",
  Single_Counselling_Type: ":id/view",
  VIEW_APPRAISAL_PERIOD: ":id/view",
  PIP: "performance-improvement-plan",
  Weekend_Allowance_Setup: "weekend-allowance-setup",
  Auxiliary_Service_Setup: "auxiliary-service-setup",
  Auxiliary_Service_Request: "auxiliary-service-request",
  add_auxiliary_service_request: "add-auxiliary-service-request",
  Auxiliary_Service_Approval: "auxiliary-service-approval",
  Repayment_Plan_Setup: "repayment-plan-setup",
  Repayment_Plan_Approval: "repayment-plan-approval",
  query_request: "query-request",
  add_query_request: "add-query-request",
  query_approval: "query-approval",
  update_query_request: "update-query-request",
  Peer_Reveiw: "peer-review",
  Upward_Review: "upward-review",
  Cross_Review: "cross-review",
  PerfomanceAppraisal: "performance-appraisal",
  Payroll_Structure: "payroll-structure",
  Add_Payroll_Structure: "add-payroll-structure",
  Update_Payroll_Structure: "update-payroll-structure",
  Medical_Limit_Setup: "medical-limit-setup",
  Add_Medical_Limit_Setup: "add-medical-limit-setup",
  Employee_PIP: "employee-pip",

  Loan_Setup: "loan-setup",
  Add_Loan_Setup: "add-loan-setup",

  Loan_Rule_Setup: "loan-rule-setup",
  Add_Loan_Rule_Setup: "add-loan-rule-setup",

  Loan_Requisition: "loan-requisition",
  Add_Loan_Requisition: "add-loan-requisition",

  Employee_Medical_Requisition: "employee-medical-requisition",
  Add_Employee_Medical_Requisition: "add-employee-medical-requisition",
  Add_Employee_Procurement_Requisition: "add-employee-procurement-requisition",

  Directorate: "directorate",
  Add_Directorate: "add-directorate",

  Memo_Requisition: "memo-requisition",
  Add_Memo_Requisition: "add-memo-requisition",

  Payment_Requisition: "payment-requisition",
  Add_Payment_Requisition: "add-payment-requisition",

  Weekend_Allowance: "weekend-allowance",
  Weekend_Allowance_Hod: "weekend-allowance-hod",
  Add_Weekend_Allowance: "add-weekend-allowance",
  Update_Weekend_Allowance: "update-weekend-allowance",

  Add_Applicant: "add-applicant",

  Signin_Applicant: "signin-applicant",

  Extended_HMO_Claims: "extended-hmo-claims",

  Add_Extended_HMO_Claims: "add-extended-hmo-claims",

  finance: "finance",
  PayrollAutorun: "Payroll-Autorun",
  CooperativeSetup: "Cooperative-Setup",
  BudgetImport: "Budget-Import",
  CostCentre: "Cost-Centre-Service",
  CostCenterSetup: "Setup",
  CostCenterClass: "Class",
  CostCenterClassSetup: "Class-Setup",
  CostCenterExpenses: "Cost-Centre-Expenses",
  PaymentService: "Payment-Service",
  SetupPaymentLimit: "setup_payment_limit",
  CompanyFund: "Company-Fund",
  PaymentSetup: "Payment-Setup",
  WitholdingTaxSetup: "Witholding-Tax-Setup",
  ExchangeRateSetup: "ExchangeRateSetup",
  PaymentRecognitionSetup: "Payment-Recognition-Setup",
  Payment: "Payment",
  PaymentSetupHOD: "Payment-Setup-HOD",
  PaymentType: "PaymentType",
  PaymentRequest: "Payment-Request",
  PaymentRequestHOD: "Payment-Request-HOD",
  DownloadPaymentRequest: "Download-Payment-Request",
  PaymentLog: "PaymentLog",
  PaymentDetails: "Payment-Details",
  Narration: "Narration",
  ManageRoles: "Manage-Roles",
  SetupAService: "Setup-A-Service",
  AccountSetup: "account-setup",
  ServiceDetailsView: "Service-details-view/:id",
  AccountDetailsView: "Account-details-view/:id",
  CreateService: "Create-Service",
  AttachAccount: "Attach-Account",
  AddFacilities: "Add-Book-Service-Facilities/:id",
  UpdateService: "Update-Service/:data",
  UpdateServiceBookings: "Update-Service-Bookings",
  ServiceBookingDetails: "Service-Booking-Details/:id",
  BookAService: "Book-A-Service",
  CreateNewService: "Create-New-Service",
  ManageBookingRequest: "Manage-Booking-Request",
  ManageBookingRequestView: "ManageBookingRequestView",
  BookingsServiceDetails: "Bookings-Service-Details/:id",
  CooperativeComponent: "Cooperative-Component",
  CreateCooperativeComponent: "CreateCooperativeComponent",
  CooperativeSetupDetails: "CooperativeSetupDetails",
  AssignCooperativeReviewer: "AssignCooperativeReviewer",
  // BudgetImport: "BudgetImport",
  BudgetImportDetails: "BudgetImportDetails",
  CreditFacility: "CreditFacility",
  AddCreditFacility: "Add-CreditFacility",
  VeiwCreditFacility: "VeiwCredit/:id",
  NonStatutoryAdviceManagement: "NonStatutoryAdviceManagement",
  NonStatutoryAdviceApproval: "NonStatutoryAdviceApproval",
  NonStatutoryAdviceReviewer: "NonStatutoryAdviceReviewer",
  NonStatutoryAdviceReviewerDetails: "NonStatutoryAdviceReviewerDetails/:data",
  NonStatutoryAdviceApprovalDetails: "NonStatutoryAdviceApprovalDetails/:data",
  NonStatutoryAdviceApprovalComp: "NonStatutoryAdviceApprovalComp",
  CooperativeManagement: "CooperativeManagement",
  CooperativeManagementApproval: "CooperativeManagementApproval",
  CooperativeManagementReviewer: "CooperativeManagementReviewer",
  CooperativeManagementReviewerDetails:
    "CooperativeManagementReviewerDetails/:data",
  CooperativeManagementApprovalDetails:
    "CooperativeManagementApprovalDetails/:data",
  CooperativeManagementApprovalComp: "CooperativeManagementApprovalComp",
  AssetNBV: "AssetNBV",
  AccountingLedgerSetup: "AccountingLedgerSetup",
  AccountingLedger: "AccountingLedger",

  //Employee Routes
  Employee: "employee",
  Training: "training",
  Leave_Requisition: "Leave-Request",
  Add_Leave: "Add-Leave",
  View_Leave: "view-leave",
  leave_Recall: "Leave-Recall",
  Exit_Requisition: "Exit-Requisition",
  Exit_HOD: "Exit_HOD",
  Exit_Discussion: "Exit-Discussion",
  Overtime_Requisition: "Overtime_Requisition",
  Query: "Query",
  Query_By_HOD: "Query-By-HOD",
  Query_By_HOC: "Query-By-HOC",
  My_Query: "My-Query",
  Query_Response: "Query-Response",
  My_Query_Response: "My-Query-Response",
  My_Employee_Info: "My-Employee-Info",
  Add_My_NOK: "Add-My-NOK",
  My_NOK_Information: "My-NOK-Info",
  My_Medical_Requisition: "My-Medical-Requisition",
  Add_My_Medical: "Add-My-Medical",
  Add_Employee_Qualification: "Add-Qualification",
  Employee_Qualification: "Employee-Qualification",
  Employee_Refs: "Employee-Refs",
  Add_Employee_Referee: "Add-Employee-Referee",
  Add_Employee_Claim: "Add-claim",
  Employee_Extended_Claim: "Employee-Claim",
  Payroll: "Payroll",
  Payroll_Run: "payroll-run",
  Staff_Renumeration: "staff-renumeration",

  Relationship: "relationship",

  // settings
  Settings: "settings",
  Permissions: "permissions",
  Permission_Group: "permissions-group",
  Grant_Permission: "grant-permission",
  Create_Staff: "create-staff",
  Edit_Staff: "edit-staff",
  Edit_Staff_Permissions: "edit-staff-permissions",

  //Consumable
  Consumables: "Consumables",
  Consumable_Acqusition: "acq",
  Consumable_Allocation: "all",
  Consumable_Requsition: "req",

  //Asset Set Up
  AssetSetUp: "Asset-Setup",
  AssetRegister: "AssetRegister",
  Categories: "Categories",
  Budget: "Budget",

  //sTORE & iNVENOTRU
  ConsummableSetUp: "Consummable-Setup",
  ConsummbaleRegister: "ConsummableRegister",
  ConsummableCategories: "Categories",
};
